import React from 'react'
import { Button, Form, Input, message } from 'antd'
import profileService from '../../services/profileService'

type FormValues = {
    firstName: string;
    lastName: string;
    job: string;
    biography: string;
    contactEmail?: string;
}

type Props = {
    firstName: string;
    lastName: string;
    job: string;
    biography: string;
    role: number;
    contactEmail?: string;
}

const ProfileInfoForm: React.FC<Props> = ({ firstName, lastName, job, biography, role, contactEmail }) => {
  const onFinish = ({ firstName, lastName, job, biography, contactEmail }: FormValues) => {
    profileService.updateInfo(firstName, lastName, job, biography, contactEmail).then(() => {
      message.success('update success')
    }).catch(() => {
      message.error('update error')
    })
  }

  return (
        <Form
            onFinish={onFinish}
            layout="vertical"
            initialValues={{
              firstName,
              lastName,
              job,
              biography,
              contactEmail
            }}>
            <Form.Item label="Имя" name="firstName" rules={[{ required: true }]}>
                <Input/>
            </Form.Item>
            <Form.Item label="Фамилия" name="lastName" rules={[{ required: true }]}>
                <Input/>
            </Form.Item>
            <Form.Item label="Должность" name="job">
                <Input/>
            </Form.Item>
            <Form.Item label="Биография" name="biography">
                <Input.TextArea rows={4}/>
            </Form.Item>
            {role === 2 && (
              <Form.Item label="Контактный email" name="contactEmail" rules={[{ type: 'email', message: 'Введите корректный email' }]}>
                  <Input/>
              </Form.Item>
            )}
            <Form.Item>
                <Button htmlType="submit" type="primary">Изменить</Button>
            </Form.Item>
        </Form>
  )
}

export default ProfileInfoForm
